/*
 * @Description: 应用引导下载条
 */
import React, { memo } from 'react';
import { Flex } from 'antd-mobile';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ImgWrap from 'pubBiz/ImgWrap';
import Config from 'config/Config';
import Util from 'utils';
import styles from './index.modules.less';

const CDN_BASE = Config.CDN_BASE || '';

const DownLoadBar = memo((props) => {
  const { hideBar } = props;
  let sourceTypeParams = Util.getLocalCache('sourceTypeParams');
  let sourceXversePopup = Util.getLocalCache('sourceXversePopup') || '';

  // 点击事件
  const handleClick = () => {
    window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.yofoto.yofoys');
  };

  if (!!sourceTypeParams || !!sourceXversePopup) return null; // 元宇宙
  if (
    [
      'cxwygj.com',
      'h5.cxwygj.com',
      'intl.yofogo.com',
      'foreign.yofogo.com',
      'h5.nbmqdz.com',
      'h5.uat3.nbmqdz.com',
      'h5.uat5.nbmqdz.com',
      'web.sanshengjk.cn',
      'h5.nbxpdz.com',
      'intl.fanxinggj.com',
      'foreign.fanxinggj.com',
      'foreignh5.uat3.yofoys.cn'
    ].includes(location.host)
  )
    return null; // 国际版

  return (
    <Flex
      className={cx(styles.downloadBar, {
        [styles.hide]: hideBar,
        [styles.show]: !hideBar
      })}
      justify="between"
      align="center"
      style={props.style}
      onClick={() => handleClick()}>
      <ImgWrap className={styles.barImg} src={`${CDN_BASE}/assets/imgs/download_bar.png`} />
    </Flex>
  );
});

DownLoadBar.defaultProps = {
  hideBar: false
};

DownLoadBar.propsTypes = {
  hideBar: PropTypes.bool // 是否隐藏下载条
};

export default DownLoadBar;



// WEBPACK FOOTER //
// ./src/pubBiz/DownloadBar/index.js